import Store from '../../helpers/store';

export default class ResistancesStore extends Store {}


// WEBPACK FOOTER //
// ./js/models/resistances/resistancesStore.js